import A11yDialog from "a11y-dialog";

const isiTray = document.getElementsByClassName("isi-tray");

// let timeoutId;

 window.closeModal = () => {
    let modalClose = document.querySelector('#acrSpeedBump .dialog-close');
    clearTimeout(timeoutId);
     modalClose.click();
 };
// window.openModalWithRedirect = (href) => {
//     event.preventDefault();
//     timeoutId = setTimeout(function(){
//         window.open(href, '_blank');
//         closeModal();
//     }, 5000);   
// };

document.addEventListener('DOMContentLoaded', function() {
  const dialogElement = document.getElementById('acrSpeedBump');
  const guidelineLink = document.getElementById('acrGuidelineLink'); // Get the link element

  // Check if the dialog element exists and if it hasn't been shown in this session yet
  if (dialogElement && !sessionStorage.getItem('dialogShownThisSession')) {
    // Instantiate the A11yDialog
    const dialog = new A11yDialog(dialogElement);

    // Set a timeout to show the dialog after 5 seconds (5000 milliseconds)
    setTimeout(function() {
      dialog.show();
      // Mark that the dialog has been shown in this session
      sessionStorage.setItem('dialogShownThisSession', 'true');
    }, 1000); // 5000 milliseconds = 5 seconds

    // Add an event listener to the guideline link
    if (guidelineLink) {
      guidelineLink.addEventListener('click', function() {
        dialog.hide(); // Dismiss the dialog when the link is clicked
      });
    }
  }
});



export default () => {
    let links = document.querySelectorAll("[data-a11y-dialog-show]");
    for (let i = 0; i < links.length; i++) {
         if (links[i].getAttribute("data-a11y-dialog-show") !== "ACRguidlinesmodal") {
            links[i].addEventListener("click", (e) => {
                e.preventDefault();
                isiTray[0].style.zIndex = '1020';
                let modal = document.getElementById(
                    links[i].getAttribute("data-a11y-dialog-show")
                );
                let href = links[i].getAttribute("href");
                let cont = modal.querySelector("a");
                cont.setAttribute("href", href);
            });
        }
    }
};